import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['select', 'button'];

  // https://stackoverflow.com/a/72261935
  initialize() {
    this.selectTargets.forEach((target) => {
      $(target).offon('select2:select', () => {
        let event = new Event('change', { bubbles: true });
        target.dispatchEvent(event);
      });
    });
  }

  enable() {
    this.buttonTarget.removeAttribute("disabled");
  }
}
